// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Remove browser defaults */
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
.App {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

div.p2eadmin {
  width: 95%;
  float: left;
  border: 1px solid grey;
  border-radius: 25px;  
  padding: 10px;
}

div.p2eadmin h3 {
    width: 100%;
    clear: both;
    font-size: 18px;
}

div.navigation {
  width:100px;
  height: 100%;
  text-align: center;
  float: left;
}

div.navigation p {
  background-color: #8080D8;
  border: 1px solid grey;
  border-radius: 3px;
  margin: 5px;
}

/* Tab Container under P2EAdmin*/
.Tabs {
  width: 1000px;
  height: 450px;
  background: #053742;
  margin: 15px auto 7px;
  padding: 10px 5px;
  color: #E8F0F2;
  border-radius: 10px;
  @media (max-width: 769px) {
    padding: 10px 0;
  }

}

/* Tab Navigation */
ul.nav1,
ul.nav {
  width: 60%;
  margin: 0 auto 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #39A2DB;
  border-radius: 10px;
  @media (max-width: 768px) {
    width: 90%;
  }
}
ul.nav1 li,
ul.nav li {
    width: 50%;
  padding: 5px;
  list-style: none;
  text-align: center;
  cursor: pointer;
  transition: all 0.7s;
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
}
/*ul.nav li:nth-child(2) {*/
  ul.nav1 li:first-child,
  ul.nav li:first-child {
    border-bottom-right-radius: 10px;
    border-top-right-radius: 10px;
}
ul.nav1 li:last-child,
ul.nav li:last-child {
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
}
ul.nav1 li:hover,
ul.nav li:hover {
  background: rgba(50, 224, 196, 0.15);
}
ul.nav li.gametab {
  background: #214225;
}
ul.nav1 li.hidden,
ul.nav li.hidden {
  display: none;
}
ul.nav1 li.active,
ul.nav li.active {
  background: #39A2DB;
}

/* First and Second Tab Styles */
.GetAsset p,
.AddAsset p,
.ConsumeAsset p {
  font-size: 5px;
  text-align: center;
}

div.copy {
  float: right;
  top: 0px;
  right: 0px;
  background: grey;
  color:blue;
  border-radius: 5px;
  padding: 5px;
}

div.form,
div.encrypted,
div.raw {
  padding: 10px;
  margin: 5px;
  font-size: 10pt;
  border: 1px solid grey;
  border-radius: 10px;
  float:left;
  width: 300px;
  height: 300px;
  overflow:scroll;
}

div.raw {
  word-wrap: break-work;
  font-style: italic;
}

textarea.rawinput, 
textarea.encrypted {
  width:280px;
  resize: none;
  height: 150px;
  background: rgb(206, 206, 206);
}`, "",{"version":3,"sources":["webpack://./src/components/Play2earn/P2Eadmin/index.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,sBAAsB;EACtB,UAAU;EACV,SAAS;AACX;AACA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;;AAEA;IACI,WAAW;IACX,WAAW;IACX,eAAe;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB;IACE,eAAe;EACjB;;AAEF;;AAEA,mBAAmB;AACnB;;EAEE,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB;IACE,UAAU;EACZ;AACF;AACA;;IAEI,UAAU;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,+BAA+B;EAC/B,4BAA4B;EAC5B,gCAAgC;EAChC,6BAA6B;AAC/B;AACA,2BAA2B;EACzB;;IAEE,gCAAgC;IAChC,6BAA6B;AACjC;AACA;;EAEE,gCAAgC;EAChC,6BAA6B;AAC/B;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;;;EAGE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,YAAY;AACd;;AAEA;;;EAGE,aAAa;EACb,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;AAChC","sourcesContent":["/* Remove browser defaults */\n* {\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n}\n.App {\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\ndiv.p2eadmin {\n  width: 95%;\n  float: left;\n  border: 1px solid grey;\n  border-radius: 25px;  \n  padding: 10px;\n}\n\ndiv.p2eadmin h3 {\n    width: 100%;\n    clear: both;\n    font-size: 18px;\n}\n\ndiv.navigation {\n  width:100px;\n  height: 100%;\n  text-align: center;\n  float: left;\n}\n\ndiv.navigation p {\n  background-color: #8080D8;\n  border: 1px solid grey;\n  border-radius: 3px;\n  margin: 5px;\n}\n\n/* Tab Container under P2EAdmin*/\n.Tabs {\n  width: 1000px;\n  height: 450px;\n  background: #053742;\n  margin: 15px auto 7px;\n  padding: 10px 5px;\n  color: #E8F0F2;\n  border-radius: 10px;\n  @media (max-width: 769px) {\n    padding: 10px 0;\n  }\n\n}\n\n/* Tab Navigation */\nul.nav1,\nul.nav {\n  width: 60%;\n  margin: 0 auto 10px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid #39A2DB;\n  border-radius: 10px;\n  @media (max-width: 768px) {\n    width: 90%;\n  }\n}\nul.nav1 li,\nul.nav li {\n    width: 50%;\n  padding: 5px;\n  list-style: none;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.7s;\n  border-bottom-left-radius: 10px;\n  border-top-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n  border-top-right-radius: 10px;\n}\n/*ul.nav li:nth-child(2) {*/\n  ul.nav1 li:first-child,\n  ul.nav li:first-child {\n    border-bottom-right-radius: 10px;\n    border-top-right-radius: 10px;\n}\nul.nav1 li:last-child,\nul.nav li:last-child {\n  border-bottom-right-radius: 10px;\n  border-top-right-radius: 10px;\n}\nul.nav1 li:hover,\nul.nav li:hover {\n  background: rgba(50, 224, 196, 0.15);\n}\nul.nav li.gametab {\n  background: #214225;\n}\nul.nav1 li.hidden,\nul.nav li.hidden {\n  display: none;\n}\nul.nav1 li.active,\nul.nav li.active {\n  background: #39A2DB;\n}\n\n/* First and Second Tab Styles */\n.GetAsset p,\n.AddAsset p,\n.ConsumeAsset p {\n  font-size: 5px;\n  text-align: center;\n}\n\ndiv.copy {\n  float: right;\n  top: 0px;\n  right: 0px;\n  background: grey;\n  color:blue;\n  border-radius: 5px;\n  padding: 5px;\n}\n\ndiv.form,\ndiv.encrypted,\ndiv.raw {\n  padding: 10px;\n  margin: 5px;\n  font-size: 10pt;\n  border: 1px solid grey;\n  border-radius: 10px;\n  float:left;\n  width: 300px;\n  height: 300px;\n  overflow:scroll;\n}\n\ndiv.raw {\n  word-wrap: break-work;\n  font-style: italic;\n}\n\ntextarea.rawinput, \ntextarea.encrypted {\n  width:280px;\n  resize: none;\n  height: 150px;\n  background: rgb(206, 206, 206);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
